import { render, staticRenderFns } from "./TicketTab.vue?vue&type=template&id=77bf661c&scoped=true&"
import script from "./TicketTab.vue?vue&type=script&lang=js&"
export * from "./TicketTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bf661c",
  null
  
)

export default component.exports